import { render, staticRenderFns } from "./QueryPage.vue?vue&type=template&id=166cb278"
import script from "./QueryPage.vue?vue&type=script&lang=js"
export * from "./QueryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports